import { Map as ImmutableMap } from 'immutable';
import DocumentMetadataRecord from 'documents-ui/records/DocumentMetadataRecord';
import GDPRRecord from 'documents-ui/records/GDPRRecord';
export const getDummyDocumentSummary = documentId => {
  // Create dummy metadata for testing when documentSummary is not available
  const dummyMetadata = {
    thumbnailUrl: 'https://via.placeholder.com/300x200',
    deckId: documentId,
    numViews: 42,
    folderId: 123,
    user: ImmutableMap({
      '1': {
        email: 'test@example.com',
        firstName: 'John',
        lastName: 'Doe'
      }
    }),
    title: 'Sample Document Title',
    meanDuration: 180,
    numShares: 5,
    createdAt: new Date('2024-01-15'),
    numUniqueVisitors: 25,
    progressionPercent: 75,
    slides: null,
    userId: 1
  };

  // Create dummy GDPR settings for testing
  const dummyGDPR = {
    deckId: documentId,
    lastUpdatedAt: Date.now(),
    lastUpdatedByUserId: 1,
    legalConsentEnabled: true
  };
  return {
    metadata: DocumentMetadataRecord(dummyMetadata),
    gdpr: GDPRRecord(dummyGDPR)
  };
};